import React from 'react';
import { Navigate } from 'react-router-dom';
import { useIsExternal } from '../hooks/useIsExternal';

interface NotForExternalRouteProps {
  children: React.ReactNode;
  /** Where an External account is sent instead. */
  redirectTo?: string;
}

/**
 * Route guard: an External account (outside contractor) is redirected away from
 * pages that exist to handle money (invoice/bill matching, billing backfill).
 * Hiding the nav link alone leaves the page one typed URL away (#5206 F1).
 * A UI guard only — the reads behind these pages are refused by firestore.rules.
 */
export function NotForExternalRoute({ children, redirectTo = '/projects' }: NotForExternalRouteProps) {
  const isExternal = useIsExternal();
  if (isExternal) return <Navigate to={redirectTo} replace />;
  return <>{children}</>;
}
